import { createReducerContext } from '../../../../utils/create-reducer-context';
import { BiddingSearchState, BiddingSearchReducer, ACTION_TYPES } from './bidding-search-reducer';

const initialState: BiddingSearchState = {
    parameters: { page: 0, pageSize: 25 },
    searchTrigger: 0,
    modalities: [],
    managementUnits: [],
    documentTypes: [],
    drawer: { open: false, files: [] },
};

const { Provider: BiddingSearchProvider, useStateContext: useBiddingSearchState, useDispatchContext: useBiddingSearchDispatch } = createReducerContext('BiddingSearch', BiddingSearchReducer, initialState);

export { BiddingSearchProvider, useBiddingSearchState, useBiddingSearchDispatch, ACTION_TYPES };
